import { Component, PLATFORM_ID, Inject, HostListener, ElementRef,NgZone } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { Router,NavigationEnd } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { ApidataService } from '../apidata.service';
import { RecaptchaModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { environment, GINConstants } from '../../environments/environments';
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { WebService } from '../services/web.service';
import swal from 'sweetalert2';
import {  RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators'
declare const gapi: any;
declare var FB: any;
@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [ HttpClientModule, CommonModule,RecaptchaModule, RouterModule ],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.css',
  providers:[ApidataService]
})
export class SignupComponent {
  emptyFields = [];
  form_firstname: any;
  form_lastname: any;
  form_email: any;
  
  recaptcha_message = ""
  got_recpatcha : boolean = false;
  captchaToken: string | null = null;
  form_password;
  captchaResponse: string;
  recaptchaSiteKey = '6LcMnOsnAAAAAExxnt0IqIEq4pSha6O_vPeOsw-1';
  form_captcha;
  fieldIf: boolean = false;
  dangerAlerts;
  user;
  idgoogle;
  color: string = 'black';
  authentication_token;
  reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  check;

  passwordFieldType: string = 'password';
  password: string = '';

  validations: boolean = false;
  valitators;

  dangerAlerts2;
 emailerror: boolean = false;
  color1;
  private _ngZone: any;



  constructor(
    private router: Router,
    private _webservice: ApidataService,
    @Inject(PLATFORM_ID) private platformID: Object,
    private httpClient: HttpClient,
     private elementRef: ElementRef
  ) {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  ngOnInit() {
    this.removeBackdrop()
  }
  public ngAfterViewInit(): void {
    this.loadTurnstileScript().then(() => this.renderTurnstile());}
 
private initializeGoogleAuth(): Promise<void> {
  return new Promise((resolve, reject) => {
    gapi.load('auth2', () => {
      gapi.auth2.init({
        client_id: '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com', 
      }).then(() => {
        resolve();
      }).catch((error) => {
        // console.error('Error initializing Google Auth', error);
        reject(error);
      });
    });
  });
}
removeBackdrop() {
  const backdrop = document.querySelector('.modal-backdrop');
  if (backdrop) {
    backdrop.remove();
  }
}
public  googleLogin(): void {
  this.initializeGoogleAuth().then(() => {
    const googleAuth = gapi.auth2.getAuthInstance();
    googleAuth.signIn({ scope: 'profile email' }).then(googleUser => {
      localStorage.setItem('token', 'id_token');
      this.onSignIn(googleUser);
    }).catch(error => {
      // console.error('Google Sign-In failed', error);
    });
  }).catch(error => {
    // console.error('Google API initialization failed', error);
  });
}
onCaptchaResolved(captchaResponse: string) {
  this.captchaResponse = captchaResponse;
}
public onSignIn(googleUser): void {
  const profile = googleUser.getBasicProfile();
  const id_token = googleUser.getAuthResponse().id_token;
  const body = {
      firstname: btoa(profile.getGivenName()),
      lastname: btoa(profile.getFamilyName()),
      email: btoa(profile.getEmail())
  };


  this.gLogin(body);
}
public fbAPI() {
  var self = this;
  let res;
 
}

public fbLogin(facebookResponse) {

  let body = JSON.stringify({
    firstname: btoa(facebookResponse.first_name),
    lastname: btoa(facebookResponse.last_name),
    email: btoa(facebookResponse.email)
  });

  this._webservice.signupinfb(body).subscribe((data) => {
    localStorage.setItem('role' , '1');

    if((data.meta.code === 200  )){
      localStorage.setItem('currentUser', JSON.stringify(data));
    this.user=data['response'];

    this.authentication_token=this.user['user'].authentication_token;
 
   this.idgoogle= this.user['user'].id;

   localStorage.setItem(this.idgoogle, 'id');
   localStorage.setItem('authentication_token', this.user['user'].authentication_token);
   localStorage.setItem('token', this.user['user'].authentication_token);



    localStorage.setItem('role' , '1');
    this._ngZone.run(() => {
    this.router.navigate(['/']);

  
    swal({
      background: "#FFFFFF",
      title: "success",
      html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/success.svg" alt="Alert" />
            <div style="    width: 369px; height: 64px; margin-left: 39px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              You have successfully logged into GrammarIn.
              </p>
            </div>
          </div>
        </div>
      `,
      showConfirmButton: false,
      width: "323px",
      timer: 4000
    });



    setTimeout(() => {
      const okButton = document.getElementById('swal-ok-button');
      if (okButton) {
        okButton.addEventListener('click', () => {
          swal.close(); 
        });
      }
    }, 0);
  })
}
  else  if((data.meta.code === 400 )){

    swal({
      background: "#FFFFFF",
      title: "Error",
      html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
            <div style="    width: 369px; height: 64px; margin-left: 39px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
               You have already registered your account from the web.
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class="mt-5 butn-alert">Ok</button>
          </div>
        </div>
      `,
      showConfirmButton: false,
      width: "323px",
      timer: 4000
    });


 
    setTimeout(() => {
      const okButton = document.getElementById('swal-ok-button');
      if (okButton) {
        okButton.addEventListener('click', () => {
          swal.close();
        });
      }
    }, 0);

}
  },

  );
}

public submitLogin() {
  var self = this;

  FB.login(function (response) {
    if (response.authResponse) {
   
      FB.api('/me', function (response) {
   
        self.fbAPI();
        localStorage.setItem('token' , 'id_token')
      });
    } else {

    }
  }, { scope: 'public_profile,email' });
}

public gLogin(body): void {
  this._webservice.signupinGoogle2(body).subscribe(data => {
    if (data.meta.code === 200) {
      localStorage.setItem('currentUser', JSON.stringify(data));
      this.user = data['response'];
      this.authentication_token = this.user['user'].authentication_token;
      this.idgoogle = this.user['user'].id;
      localStorage.setItem('fullname',this.user['user'].verify)
      localStorage.setItem(this.idgoogle, 'profile_id');
      localStorage.setItem(this.user['user'].authentication_token, 'token');
      localStorage.setItem(this.user['user'].authentication_token, 'authentication_token');
 
      localStorage.setItem('profile_id', this.idgoogle);


      localStorage.setItem('role', '1');
      localStorage.setItem('fullname',this.user['user'].verify)
  
        this.router.navigate(['/']).then(() => {
    
          window.location.reload();
        });


        swal({
          background: "#FFFFFF",
          title: "success",
          html: `
            <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
              background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
              <div class="text-center" style="margin-top: 9%;">
                <img src="/assets/images/paraphrasing tool/success.svg" alt="Alert" />
                <div style="    width: 369px; height: 64px; margin-left: 39px;">
                  <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                  You have successfully logged into GrammarIn.
                  </p>
                </div>
              </div>
            </div>
          `,
          showConfirmButton: false,
          width: "323px",
          timer: 4000
        });
   
    } else if (data.meta.code === 400) {
   
      swal({
        background: "#FFFFFF",
        title: "Error",
        html: `
          <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
            background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
            <div class="text-center" style="margin-top: 9%;">
              <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
              <div style="    width: 369px; height: 64px; margin-left: 39px;">
                <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                 You have already registered your account from the web.
                </p>
              </div>
              <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                class="mt-5 butn-alert">Ok</button>
            </div>
          </div>
        `,
        showConfirmButton: false,
        width: "323px",
        timer: 4000
      });


    
      setTimeout(() => {
        const okButton = document.getElementById('swal-ok-button');
        if (okButton) {
          okButton.addEventListener('click', () => {
            swal.close();
          });
        }
      }, 0);
    }
  }, error => {
    // console.error('Login error', error);
  });
}
  navigateTosignin() {
    this.router.navigate(['/signin']);
  }
  navigateTosiforgot() {
    this.router.navigate(['/forgot-password']);
  }
  navigateToPrivacyPolicy() {
    this.router.navigate(['/privacy-policy']);
  }
  navigateToTermsConditions() {
    this.router.navigate(['/terms-conditions']);
  }
  navigateToHome() {
    this.router.navigate(['']);
  }
  public checkEmptyFields(form) {
    let emptyFields = [];

    if (form.form_firstname === '') {
      emptyFields.push('firstname');
    }
    if (form.form_lastname === '') {
      emptyFields.push('lastname');
    }
    if (form.form_email === '') {
      emptyFields.push('email');
    }
    if (form.form_password === '') {
      emptyFields.push('pass_log_id5');
    }

    return emptyFields;
  }

  FormSubmission(event) {
    event.preventDefault();
    this.fieldIf = false;
    $('#dangerAlerts').hide();

    this.form_firstname = $('#firstname').val();
    this.form_lastname = $('#lastname').val();
    this.form_email = $('#email').val();
    this.form_password = $('#pass_log_id5').val();
   

    let form = {
      form_firstname: this.form_firstname,
      form_lastname: this.form_lastname,
      form_email: this.form_email,
      form_password: this.form_password,
 
    };
    let emptyFields = this.checkEmptyFields(form);
    if (emptyFields.length > 0) {
      this.showAlert("Please provide the required fields","")
    }
    else if (
      typeof this.form_email === 'string' &&
      this.reg.test(this.form_email) === false
    ) {
      this.showAlert("Please provide correct Email","#email")
    } else if (this.form_password === this.form_email) {
      this.showAlert("This password is too similar to your email address.Please choose another password","#pass_log_id5")

    }
  
    else {
      const headers = new HttpHeaders({
        Authorization: environment.AuthorizationGIN,
      });

      this.httpClient
        .post(
          environment.API_URL+'/api/signupFormProcesses',
          {

            firstname: this.form_firstname,
            lastname: this.form_lastname,
            email: this.form_email,
            password: this.form_password,
          },
          { headers }
        )
        .subscribe(
          (response) => {
        
            localStorage.setItem('signupid', response['response'].user_id);
       
             if ((response['meta'].code === 401) && (response['response']['errors'].signup_message === "You have verified your account. Please log in to use your account"))
               {
              this.showAlert("You have verified your account. Please log in to use your account.","");
            }
           else if ((response['meta'].code === 401) && (response['response']['errors'].signup_message === "Sorry! this account already exists. Please log in from your social account"))
              {
             this.showAlert("Sorry! this account already exists. Please log in from your social account","");
           }
            else if (
             ( response['meta'].code === 401) &&
              (response['response']['errors'].signup_message ===
                'Please verify your account first.')
            ) {

              this.showAlert("Please verify your account first","");
            } else if (
              (response['meta'].code === 400) &&
             ( response['response']['errors'].signup_message ===
                'Sorry! this account already exists.')
            ) {

              this.showAlert("Sorry! this account already exists","");
            }  else if(
             ( response['meta'].code === 200) &&
             ( response['response'].signup_message ===
                "Account Created Successfully, Please Sign In to Continue")
            )
            {
              this.router.navigate(['/verifyemail']);
            
              this.resetForm();
            }
          },
          (error) => {
            // console.error(error);
          }
        );



    }
  }
 
  showAlert(message, selector) {
    this.color = '#721c24';
    this.dangerAlerts = message;
    $(selector).css('border-color', 'red');
    this.fieldIf = true;
    $('#dangerAlerts').show();
    setTimeout(() => {
      $('#dangerAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.fieldIf = false;
    }, 5000);
  }
  showSuccess(message, selector) {
    this.color1 = 'green';
    this.dangerAlerts2 = message;
    this.emailerror = true;
    $('#dangerAlerts2').show();
    setTimeout(() => {
      $('#dangerAlerts2').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.emailerror = false;
    }, 4000);
  }

  resetForm() {
    $('#firstname').val('').css('border-color', '#e7e7ec');
    $('#lastname').val('').css('border-color', '#e7e7ec');
    $('#email').val('').css('border-color', '#e7e7ec');
    $('#pass_log_id5').val('').css('border-color', '#e7e7ec');
    $('#captcha').prop('checked', false).css('border-color', '#e7e7ec');
  }

  disableCaptcha(event) {
    $(event.target).attr('disabled', 'disabled');
  }

  togglePasswordVisibility(): void {
    this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password';
  }

  onFocus() {
    this.validations = true;

  }


  isDropdownVisible = false;
  selectedLanguage = {
    name: 'English',
    icon: '../../assets/images/plagiarism checker1/language.svg'
  };



  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }


  selectLanguage(name: string, icon: string) {
    this.selectedLanguage.name = name;
    this.selectedLanguage.icon = icon;
    this.isDropdownVisible = false; 
  }

 
  @HostListener('document:click', ['$event'])
  closeDropdownOnOutsideClick(event: Event) {
    const clickedElement = event.target as HTMLElement;
    if (!this.elementRef.nativeElement.contains(clickedElement) && !clickedElement.classList.contains('dropbtn')) {
      this.isDropdownVisible = false;
    }
  }

@HostListener('document:click', ['$event'])
handleOutsideClick(event: Event) {
  const target = event.target as HTMLElement;


  if (!this.elementRef.nativeElement.contains(target) && !target.classList.contains('dropbtn')) {
    this.isDropdownVisible = false;
  }
}
////// hidden recaptcha strat

loadTurnstileScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window['turnstile'] !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject('Failed to load Turnstile script');
    document.body.appendChild(script);
  });
}

renderTurnstile(): void {
  if (typeof window['turnstile'] !== 'undefined') {
    window['turnstile'].render('#recaptcha-container', {
      sitekey: environment.CaptchaKey, 
      size: 'normal',  
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
 
  } else {
    // console.error('Turnstile script not loaded.');
  }
}


handleButtonClick($event): void {
  if (this.captchaToken) {

    this.FormSubmission($event);
    this.got_recpatcha = false;
  } else {
    this.got_recpatcha = true;
  
    this.showAlert("Captcha is not loaded. Please reload the page.","")

  }
}


onTurnstileSuccess(token: string): void {

  this.captchaToken = token;  
}


onTurnstileError(): void {
  // console.error('Turnstile error occurred.');
  this.captchaToken = null;
}


///// recaptcha end

}
